export default __webpack_public_path__ + "static/9-eba8e40c55fcaa9a824755139fb304e8.webp";